module.exports = __webpack_public_path__ + "static/media/Lato-Bold.cfc7a0ef.woff2";